import React from "react";
import { Link, useLocation } from "react-router-dom";
 
import { ArrowForwardIos } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
function BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
 
  return (
    <div className="bintransfer-breadcrumb notification-breadcrumb container-fluid  ps-0">
      {vPathName === "/segregationSummary" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
           Segregation-Summary{" "}
          </span>
        </div>
      ) : vPathName === "/segregationItemScan" ? (
        <div className="d-flex align-items-center ps-0">
          <Link
            to="/segregationSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2 ps-0"}
          >
            Segregation-Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "5px" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              ItemScan{" "}
            </span>
          </div>
        </div>
      )  : vPathName === "/segregrationDetail" ? (
        <>
          {/* <Grid container spacing={0} columns={{ xs: 2, sm: 3, md: 12 }}>
            <Grid item xs={0.5} md={0.8}>
              <Link
                to="/segregationSummary"
                state={location}
                // style={{ fontSize: '1rem', marginRight: '1rem' }}
                className={"breadcrumb-active mr-2"}
              >
                 Summary
              </Link>
            </Grid>
            <Grid item xs={0.2}>
              <ArrowForwardIos color="info" style={{ marginRight: "10px" }} />
            </Grid>
            
            <Grid
              item
              xs={0.5}
              md={0.7} 
              
            >
              <Link
                to="/segregationItemScan"
                state={location}
                // style={{ fontSize: '1rem', marginRight: '1rem' }}
                className={"breadcrumb-active  "}
              >
                ItemScan
              </Link>
            </Grid>
            <Grid
              item
              xs={0.2}
            
              
            >
              <ArrowForwardIos color="info"   />
            </Grid>
            <Grid item xs={0.5} md={0.8}>
              <span
                className="breadcrumb-not-active"
                //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
              >
                Detail{" "}
              </span>
            </Grid>
          </Grid> */}
           <div className="d-flex align-items-center">
          <Link
            to="/segregationSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Segregation-Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "5px" }} />
          <Link
            to="/segregationItemScan"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            ItemScan
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "5px" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              Detail{" "}
            </span>
          </div>
        </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
export default BreadCrumbs;
